import { __rest } from '../../_virtual/_tslib.js';
import { StageWrapper } from '@lsg/shared';
import { createElement } from 'react';

/** @deprecated */

var StageThemes;

(function (StageThemes) {
  StageThemes["LIGHT"] = "light";
  StageThemes["DARK"] = "dark";
})(StageThemes || (StageThemes = {}));

var defaultProps = {
  headline: "",
  leadText: "",
  scrollerText: ""
};

var Stage = function Stage(_a) {
  var leadText = _a.leadText,
      leadTextAs = _a.leadTextAs,
      scrollerText = _a.scrollerText,
      props = __rest(_a, ["leadText", "leadTextAs", "scrollerText"]);

  return /*#__PURE__*/createElement(StageWrapper, Object.assign({}, props, {
    subline: leadText,
    sublineAs: leadTextAs,
    scrollerLabel: scrollerText
  }));
};

Stage.Themes = StageThemes;
Stage.defaultProps = defaultProps;
Stage.displayName = "Stage";

export { Stage, StageThemes };
